import axios from "axios";
import { useState } from "react";
import Swal from "sweetalert2";
import { initalRoom } from "../../const";
import { validateImageFiles } from "../../../../../utils/validateImageFiles";

export const useAddRoom = () => {
  const [imageFiles, setImageFiles] = useState([]);
  const [loading, setLoading] = useState(false); // For loading state
  const [errors, setErrors] = useState({});
  const [room, setRoom] = useState(initalRoom);

  const handleFacilityChange = (selectedFacilities) => {
    setRoom((prev) => ({ ...prev, facilities: selectedFacilities }));
  };

  const handleImageChange = ({ fileList }) => {
    setImageFiles(fileList.map((file) => file.originFileObj));
  };

  const validateFields = () => {
    const {
      name,
      type,
      rentperday,
      maxcount,
      description,
      maxadult,
      maxchild,
      roomview,
      roomsize,
      bedding,
      facilities,
      manualBeds,
    } = room;
    const newErrors = {};
    const isErrorImage = validateImageFiles({ files: imageFiles });
    if (!name) newErrors.name = "Room Name is required.";
    if (!type) newErrors.type = "Room Type is required.";
    if (!rentperday) newErrors.rentperday = "Room Rate is required.";
    if (!maxcount) newErrors.maxcount = "Number of Rooms is required.";
    if (!description) newErrors.description = "Room Description is required.";
    if (!maxadult) newErrors.maxadult = "Maximum Adults is required.";
    if (!maxchild) newErrors.maxchild = "Maximum Children is required.";
    if (!roomview) newErrors.roomview = "Room View is required.";
    if (!roomsize) newErrors.roomsize = "Room Size is required.";
    if (isErrorImage) {
      newErrors.imageFiles = isErrorImage;
    }
    if (!bedding) newErrors.bedding = "Bedding type is required.";
    if (bedding === "Input No of Bed Manually" && !manualBeds) {
      newErrors.manualBeds = "Number of Beds is required.";
    }
    if (facilities.length === 0)
      newErrors.facilities = "At least one facility is required.";
    return newErrors;
  };

  async function addRoom() {
    const {
      name,
      type,
      rentperday,
      maxcount,
      description,
      maxadult,
      maxchild,
      roomview,
      roomsize,
      bedding,
      facilities,
      manualBeds,
      extrabed,
      smokingpolicy,
    } = room;
    const newErrors = validateFields();

    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      return;
    }

    setLoading(true); // Start loading
    const formData = new FormData();
    formData.append("name", name);
    formData.append("rentperday", rentperday);
    formData.append("maxcount", maxcount);
    formData.append("description", description);
    formData.append("type", type);
    formData.append("maxadult", maxadult);
    formData.append("maxchild", maxchild);
    formData.append("extrabed", extrabed);
    formData.append("roomview", roomview);
    formData.append("roomsize", roomsize);
    formData.append("smokingpolicy", smokingpolicy);
    formData.append("facilities", facilities);
    formData.append(
      "bedding",
      bedding === "Input No of Bed Manually" ? manualBeds : bedding
    );

    if (imageFiles.length > 0) {
      for (let i = 0; i < imageFiles.length; i++) {
        formData.append("images", imageFiles[i]);
      }
    }

    try {
      await axios.post("/api/rooms/addroom", formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
      Swal.fire({
        title: "Congratulations",
        text: "Your Room Has Been Added Successfully",
        icon: "success",
        timer: 2000,
      }).then(() => {
        window.location.href = "/admin/roominglist"; // Redirect to RoomingListScreen
      });
    } catch (error) {
      console.log(error);
      Swal.fire({
        title: "Oops",
        text: "Something went wrong!",
        icon: "error",
        timer: 2000,
      });
    } finally {
      setLoading(false); // Stop loading
    }
  }

  const reorderImages = (startIndex, endIndex) => {
    // update imageFiles state
    const updated = Array.from(imageFiles || []);
    const [removed] = updated.splice(startIndex, 1);
    if (!removed) return;
    updated.splice(endIndex, 0, removed);
    // setImageFiles is from useAddRoom
    setImageFiles(updated);
  };

  const handleImageRemove = async (file) => {
    // Remove the image from the list (for new files not yet uploaded to the backend)
    setImageFiles((prevFiles) =>
      prevFiles.filter((img) => img.uid !== file.uid)
    );
  };

  return {
    addRoom,
    handleFacilityChange,
    handleImageChange,
    loading,
    errors,
    room,
    setRoom,
    setErrors,
    imageFiles,
    reorderImages,
    handleImageRemove,
  };
};
